import React from "react";
import Paper from "@material-ui/core/Paper";
import Style from "../../styles/js/Styles";
import AlertItem from "./AlertItem.js";

export default function ListAlerts({ alerts, updateState, updateCenter }) {
  const style = Style();

  return (
    <Paper className={style.listAlerts}>
      <div className={style.titlePaper}> Alertas Vigentes </div>
      {alerts !== undefined &&
        alerts.map((alert, index) => (
          <AlertItem
            key={index}
            alert={alert}
            updateState={updateState}
            updateCenter={updateCenter}
          />
        ))}
    </Paper>
  );
}
